export default __webpack_public_path__ + "static/media/responsive.e1a52246.png";